<template>
    <b-container >
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
            :variant="variant">
            {{alertText}}
        </b-alert>

        <div>
            <b-row class="justify-content-md-center">
                <b-col md="12" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Online Payment</p>
                    <p></p>
                    <p style="font-size: 0.875rem;">{{payment.purpose}}</p>

                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;" v-if="showdtls">
                        <span style="font-size: 0.875rem;">Please make online payment, as below:
                        </span><br/><br/>
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col md="2" sm="5" style="font-size: 0.875rem;"><strong>Details</strong></b-col>
                              <b-col md="2" sm="5" style="text-align:right;font-size: 0.875rem;"><strong>Amount</strong></b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>
                            <!-- <b-row v-for="fee in fees" :key="fee.detail">
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;">{{fee.feesDetails}}</b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;">&#8377; {{fee.fees}}</b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row> -->
                            <b-row>
                              <b-col md="4" sm="1"></b-col>
                              <b-col style="font-size: 0.875rem;"><strong>Total</strong></b-col>
                              <b-col style="text-align:right;font-size: 0.875rem;"><strong>&#8377; {{total}}</strong></b-col>
                              <b-col md="4" sm="1"></b-col>
                            </b-row>

                            <span style="font-size: 0.875rem;">Clicking the pay now button will navigate you to a secure payment site. On successful transaction you will be redirected back to the 'Security Guards Board' site. </span>
                            <p style="font-size: 1rem;color:red">*Payment Gateway Charges will be additional and as applicable. </p>
                    </div>
                </b-col>
            </b-row>
             <b-row class="mt-2 justify-content-md-center">
                <b-col style="text-align:right">
                <!-- <b-button type="submit" small variant="primary">Make Payment</b-button> -->
                <!-- <b-button type="reset" small variant="danger">Reset</b-button> -->
                <b-form method='POST' action='https://pgi.billdesk.com/pgidsk/PGIMerchantPayment'>        
                    <input type="hidden" name='msg' :value="payLoad">
                    <b-button type="submit" variant="primary" v-if="showdtls">Submit</b-button>
                </b-form>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
/*
This is central Payment page which will be called for all the payment purpose.
This module will be called by
1. B-Form Payment
2. Registration Payment of Employer, Agency and Private Guards.

@@ The calling page needs to send Payment Object to the store. @@

Since the payment of Employer and Guards which are getting registered by Agency needs to be
Combined together, we need to have a Cart object and the cart will call this payment method.
*/

import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";

export default {
  components: { Spinner },
  data() {
    return {
      msg: "",
      fees: 1050.0,
      securityID: "",
      token: "",
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      showdtls: true,
      form: {
        BoardID: "00000000-0000-0000-0000-000000000000",
        FeesType: "Registration of Employer Agency and Principal Employers",
        CategoryTypeID: "00000000-0000-0000-0000-000000000000"
      },
      total: 59,
      gst:189,
      payLoad: "",
      payment: {
        PaymentID: "00000000-0000-0000-0000-000000000000",
        EventID: "00000000-0000-0000-0000-000000000000",
        BoardID: "00000000-0000-0000-0000-000000000000",
        UserID: "00000000-0000-0000-0000-000000000000",
        TransactionStatus: "Pending",
        TransactionType: "Registration",
        TransactionAmount: 59.0,
        TransactionCharges: 0,
        Currency: "INR",
        MerchantID: "",
        PaymentStatus: false,
        UserName: "",
        Purpose: "Registration Under Reg. 13",
        BoardContribution: 0,
        BaseFees:0
      },
      board: ""
    };
  },

  methods: {
    CalculateFees() {
      let pmtobj = this.$store.getters.getPmtObj;
      //console.log(pmtobj);
      this.form.BoardID = pmtobj.BoardID;
      this.form.FeesType = pmtobj.pmtPurpose;
      this.payment.Purpose = pmtobj.pmtPurpose;
      this.payment.TransactionType = pmtobj.TransType;

      let promise = apis.getFees(this.form); //Get the Details of Payment to be made.

      promise
        .then(response => {
          if (response.status == 200) {
            
            /*The Details of First Promise will be used  to create a Payment Request for Bill Desk. */
            this.fees = response.body.FeesAmount.toFixed(2);

            this.gst = response.body.TaxAmount.toFixed(2);
            this.total = ((this.fees*1) + (this.gst*1)).toFixed(2);

            this.payment.BoardContribution = response.body.BoardContribution.toFixed(2); //Fees to be paid to Board
            this.payment.BaseFees = this.fees; //Amount without Tax
            this.payment.TransactionAmount = this.total; //Total to be charges to customer *Gateway Charges are extra

            var userinfo = this.$store.getters.loggedUser;
            this.payment.UserID = userinfo.UserId;
            this.payment.UserName = userinfo.UserName;

            let promise2 = apis.getPmtRequest(this.payment);

            promise2
              .then(response => {
                //console.log('Promise2',response);
                if (response.status == 200) {
                  localStorage.setItem("userinfo", JSON.stringify(userinfo));
                  localStorage.setItem("token", response.body.token);

                  //console.log(response.body.token);
                  this.payLoad = response.body.msg;
                  this.$store.dispatch("setPrintPmt", false);
                  //console.log("Payload", this.payLoad);
                  this.showdtls = true;
                  
                } else {
                  this.alertText = response.body;
                  this.variant = "warning";
                  this.showDismissibleAlert = true;
                }
                this.isLoading = false;
              })
              .catch(err => {
                this.alertText = err.body;
                this.showDismissibleAlert = true;
                this.variant = "danger";
                this.isLoading = false;
              });
          } else {
            this.alertText =
              "Error in calculating the Fees amount. Please try again after some time.";

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
          }
        })
        .catch(err => {
          this.alertText =
            "Error in calculating the Fees amount. Please try again after some time.";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    }
  },
  mounted() {
    //this.CalculateFees();
     this.isLoading = true;
    this.fees = 1050;
    this.gst = 189;
    this.total = 59;

    var userinfo = this.$store.getters.loggedUser;
    var SurveyData = this.$store.getters.getRegistrationDetails;

    this.payment.BoardID = SurveyData.Board;
    this.payment.UserID = userinfo.UserId;

    this.payment.UserName = userinfo.UserName;

    this.payment.Purpose = "Registration of Principal Employer";

    if (userinfo.RegistrationType == 12) {
      this.fees = 50;
      this.gst = 9;
      this.total = 59;
      this.payment.Purpose =
        "Registration of Security Guards Working with Private Agency";
    } else if (userinfo.RegistrationType == 13) {
      this.payment.Purpose = "Registration of Employer Agency";
    } else if (userinfo.RegistrationType == 14) {
      this.fees = 50;
      this.gst = 9;
      this.total = 59;
      this.payment.Purpose = "Registration of SGB Principal Employer";
      //  this.total=59;
    }
    this.payment.TransactionAmount = this.total;
    let promise2 = apis.getPmtRequest(this.payment);
    promise2
      .then(response => {
        //console.log(response);
        if (response.status == 200) {
          localStorage.setItem("userinfo", JSON.stringify(userinfo));
          localStorage.setItem("token", response.body.token);

          //console.log(response.body.token);
          this.payLoad = response.body.msg;
          this.$store.dispatch("setPrintPmt", false);
          //console.log("Payload", this.payLoad);
          this.showdtls = true;
        } else {
          this.alertText = response.body;
          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    this.isLoading = false;
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/OnlinePayment/OnlinePayment.vue